import {createSelector} from "reselect";
import {pageSelectorKeys} from "./selectorKeys";

const page_S = state => state.page;

const creatorFn = selectorKey => {
    return createSelector(page_S, data => data[selectorKey])
};

export const pageSelectors = state => {
    const sData = {};

    pageSelectorKeys.forEach(key => {
        sData[key] = creatorFn(key)(state)
    });

    return sData;
};